module.exports = __webpack_public_path__ + "fonts/trellicons.862ca7f98c7c96f0a0ac.ttf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/trellicons.ttf
// module id = EAmL
// module chunks = 13